import { render } from "./ConfirmationPopup.vue?vue&type=template&id=7b2ff613&scoped=true&ts=true"
import script from "./ConfirmationPopup.vue?vue&type=script&lang=ts"
export * from "./ConfirmationPopup.vue?vue&type=script&lang=ts"

import "./ConfirmationPopup.vue?vue&type=style&index=0&id=7b2ff613&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2ff613"]])

export default __exports__